import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { Transforms } from "@core/helpers";

@Component({
  selector: "menu-layout",
  templateUrl: "./menu-layout.component.html",
  styleUrl: "./menu-layout.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class MenuLayoutComponent {
  public position = input("left", { transform: Transforms.toPosition });
}
